var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['btn-modal', _vm.size, { disable: _vm.disable, btn: !_vm.disable }],on:{"click":_vm.onClick}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.btnInner)}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }